<template>
    <div v-if="contentIsLoaded" class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div class="col-12 mb-5">
                        <h3 class="mb-4">{{sectionBlock.sectionTitle}}</h3>
                        <div class="sep-hor-black-thick"></div>
                    </div>
                </div>
                <div v-if="globalsIsLoaded" class="row justify-content-center">
                    <div
                        v-for="(value, index) in shuffleArray(globals.globalTestimonials.testimonials.elements)"
                        :key="'testimonial-' + index"
                        class="col-12 col-md-6 col-xl-4 mb-5"
                    >
                        <div class="card-testimonial-matrix">
                            <blockquote class="medium mb-5">
                                {{ value.testimonial }}
                            </blockquote>
                            <div class="content">
                                <div>
                                    <div
                                        class="user-img bg-img"
                                        :style="{
                                            backgroundImage: `url(${value.personImg.url})`,
                                        }"
                                    >
                                    </div>
                                </div>
                                <div class="user-text">
                                    <h6 class="mb-2">{{ value.personName }}</h6>
                                    <p class="role">{{ value.personRole }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'testimonials_03',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1))
                ;[array[i], array[j]] = [array[j], array[i]]
            }
            return array.slice(0, 3)
        },
    },
    // On loaded...
    mounted() {},
}
</script>
